import { QueryKey } from 'react-query';

export function key(k1: QueryKey, ...kx: any[]): QueryKey {
  if (kx.length === 0) {
    return k1;
  }

  return ([] as QueryKey[]).concat(k1, ...kx);
}
